import { render, staticRenderFns } from "./CraneCard.vue?vue&type=template&id=0bf785dc"
import script from "./CraneCard.vue?vue&type=script&lang=js"
export * from "./CraneCard.vue?vue&type=script&lang=js"
import style0 from "./CraneCard.vue?vue&type=style&index=0&id=0bf785dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports